import { styled } from '@mui/material';
import Grid from '@mui/material/Grid2';

export const TextWrapper = styled(Grid)<{ width: string | undefined }>`
  && {
    width: ${({ width }) => width ?? '380px'};
  }

  ${({ theme }) => theme.breakpoints.between('md', 'lg')} {
    && {
      width: ${({ width }) => width ?? '328px'};
      margin: 0 auto 75px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    && {
      width: ${({ width }) => width ?? '275px'};
      margin: 0 0 34px;
    }
  }
`;
